export const BY_DATE = "BY_DATE"

export const BY_USER = "BY_USER"





// WEBPACK FOOTER //
// ./src/constants/Sessions.js